import { Link } from "@tanstack/react-router"

import { Icon } from "@/components/icon/Icon"
import {
	ADDRESS,
	COMPANY_LEGAL_NAME,
	COPYRIGHT_YEAR,
	REGISTERED_OFFICE,
	SUPPORT_EMAIL,
	SUPPORT_PHONE,
	SUPPORT_PHONE_TEL,
} from "@/constants/company"
import { EXPERT_PANEL_URL, externalLinkProps } from "@/constants/links"

export function Footer() {
	return (
		<footer className="bg-inverse-surface w-full">
			<div className="mx-auto max-w-7xl px-6 py-8">
				<div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-5 lg:gap-8">
					<div className="flex flex-col gap-3 pr-0 lg:col-span-2 lg:pr-8">
						<span className="text-headline-sm text-primary-fixed-dim font-sans font-semibold">
							Swamithra
						</span>
						<p className="text-body-md text-inverse-on-surface/70 max-w-md font-sans leading-relaxed">
							Swamithra connects individual taxpayers and Professionals with a panel
							of former Indian Revenue Service (IRS) officers to answer your queries,
							and review your draft response before you file it.
						</p>
						<div className="text-label-sm text-inverse-on-surface/60 mt-1 flex items-center gap-1.5 font-sans tracking-wider uppercase">
							<Icon
								name="verified_user"
								size={16}
								filled
								className="text-tertiary-fixed-dim"
							/>
							<span>Guidance from Former IRS Officers</span>
						</div>
					</div>

					<div className="flex flex-col gap-2.5">
						<div className="text-label-md text-inverse-on-surface mb-1 font-sans font-semibold tracking-wider uppercase">
							Services
						</div>
						<ul className="flex flex-col gap-2 text-sm">
							<li>
								<a
									href="/#services"
									className="text-inverse-on-surface/70 hover:text-primary-fixed-dim transition-colors"
								>
									Ask a Question
								</a>
							</li>
							<li>
								<a
									href="/#services"
									className="text-inverse-on-surface/70 hover:text-primary-fixed-dim transition-colors"
								>
									Get Your Draft Vetted
								</a>
							</li>
							<li>
								<a
									href="/#services"
									className="text-inverse-on-surface/70 hover:text-primary-fixed-dim transition-colors"
								>
									Personalised Assistance
								</a>
							</li>
						</ul>
					</div>

					<div className="flex flex-col gap-2.5">
						<div className="text-label-md text-inverse-on-surface mb-1 font-sans font-semibold tracking-wider uppercase">
							Company &amp; Legal
						</div>
						<ul className="flex flex-col gap-2 text-sm">
							<li>
								<Link
									to="/privacy"
									className="text-inverse-on-surface/70 hover:text-primary-fixed-dim transition-colors"
								>
									Privacy Policy
								</Link>
							</li>
							<li>
								<Link
									to="/terms"
									className="text-inverse-on-surface/70 hover:text-primary-fixed-dim transition-colors"
								>
									Terms &amp; Conditions
								</Link>
							</li>
							<li>
								<a
									href={EXPERT_PANEL_URL}
									{...externalLinkProps}
									className="text-inverse-on-surface/70 hover:text-primary-fixed-dim transition-colors"
								>
									Expert
								</a>
							</li>
							{/* <li>
								<Link
									to="/data-deletion"
									className="text-inverse-on-surface/70 hover:text-primary-fixed-dim transition-colors"
								>
									Data &amp; Account Deletion
								</Link>
							</li> */}
						</ul>
					</div>

					<div className="flex flex-col gap-2.5">
						<div className="text-label-md text-inverse-on-surface mb-1 font-sans font-semibold tracking-wider uppercase">
							Contact &amp; Support
						</div>
						<ul className="flex flex-col gap-2.5 text-sm">
							<li className="text-inverse-on-surface/70 flex items-center gap-2">
								<Icon
									name="call"
									size={16}
								/>
								<a
									href={`tel:${SUPPORT_PHONE_TEL}`}
									className="hover:text-primary-fixed-dim"
								>
									{SUPPORT_PHONE}
								</a>
							</li>
							<li className="text-inverse-on-surface/70 flex items-center gap-2">
								<Icon
									name="mail"
									size={16}
								/>
								<a
									href={`mailto:${SUPPORT_EMAIL}`}
									className="hover:text-primary-fixed-dim"
								>
									{SUPPORT_EMAIL}
								</a>
							</li>
							<li className="text-inverse-on-surface/70 flex items-center gap-2">
								<Icon
									name="location_on"
									size={16}
								/>
								<span>{ADDRESS}</span>
							</li>
						</ul>
					</div>
				</div>

				{/*
				 * Mandatory legal footer — required verbatim (in substance) on every
				 * page per the SWAMITHRA_Website_Content brief, for Google Play /
				 * App Store / Meta business verification.
				 */}
				<div className="border-inverse-on-surface/15 text-inverse-on-surface/60 text-body-sm mt-6 flex flex-col gap-2 border-t pt-4 text-center md:text-left">
					<p>
						Swamithra is a service of {COMPANY_LEGAL_NAME} · Registered office:{" "}
						{REGISTERED_OFFICE} · Email: {SUPPORT_EMAIL} · Phone: {SUPPORT_PHONE}.
					</p>
					<p>
						© {COPYRIGHT_YEAR} {COMPANY_LEGAL_NAME}. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	)
}
